import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import cloud from './cloud.png'

const useStyles = makeStyles((theme) => ({
  panel: {
    position: 'absolute',
    top: 12,
    left: 12,
    zIndex: 1000,
    backgroundColor: '#fff',
    border: '1.5px solid rgba(0,0,0,0.1)',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    borderRadius: 12,
    padding: '6px 10px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    color: 'rgba(0,0,0,0.87)',
    font:
      '500 0.75rem/1 Roboto, "Fira Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  icon: {
    width: 22,
    height: 22,
    objectFit: 'contain',
    opacity: 0.85,
  },
  value: {
    fontWeight: 700,
    color: '#232C57',
    fontSize: '0.875rem',
  },
}))

export default function CloudLegend({ cloud_coverage }) {
  const classes = useStyles()

  if (!cloud_coverage) return null

  return (
    <div className={classes.panel}>
      <img src={cloud} alt="clouds" className={classes.icon} />
      <span className={classes.value}>{cloud_coverage}</span>
    </div>
  )
}
